import { useMutation, useQuery } from 'react-query';
import queryGetNotifRules from './queries/getNotifRules';
import mutationUpdateLabel from './mutations/updateLabel';
import mutationRemoveNotifRule from './mutations/removeNotifRule';
import queryGetPartners from './queries/getPartners';

const actionsPushPayments = {
    // Notif Rules
    // Getters
    getNotifRules: (params, enabled) => useQuery(queryGetNotifRules(params, enabled)),
    // Delete notif rule
    removeNotifRule: (onSuccess, onError) => useMutation(mutationRemoveNotifRule(onSuccess, onError)),
    // NotifRules update label
    updateLabel: (onSuccess, onError) => useMutation(mutationUpdateLabel(onSuccess, onError)),

    // Partners
    // Getters
    getPartners: (params, enabled) => useQuery(queryGetPartners(params, enabled))
};

export default actionsPushPayments;